import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {accountSearchResultStateSelector} from './account-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchFiltering} from 'src/openapi/admin/models/AccountSearchFiltering';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const accountSearchResultConferenceUsersSlice = getCachedTableDataSlice<
    Record<string, number>,
    AccountSearchCriteria,
    AccountSortField,
    AccountSearchFiltering
>('accountSearchResultConferenceUsers');

export const accountSearchResultConferenceUsersActions = accountSearchResultConferenceUsersSlice.actions;

const accountSearchResultConferenceUsersCacheSelector: CachedTableCacheSelector<Record<string, number>>
    = state => state.accountSearchResult.conferenceUsers.cache;
export const accountSearchResultConferenceUsersDataSelector: CachedTableDataSelector<Record<string, number>>
    = state => state.accountSearchResult.conferenceUsers;
export const accountSearchResultConferenceUsersResultSelector = getCachedTableResultSelector(
    accountSearchResultConferenceUsersCacheSelector,
    accountSearchResultStateSelector,
);
